import { useTranslation } from 'react-i18next';
import { Business } from '../../generated/graphql';
import { AmountTable, AmountTableProps } from './Table';

export interface BusinessesTableContainerProps
  extends Pick<
    AmountTableProps,
    'title' | 'className' | 'hideOnEmpty' | 'isLoading' | 'tableRowsContainerClassName' | 'tableTitleClassName'
  > {
  businessArray?: Business[];
  onItemClicked?: (a: { business: Business }) => void;
  children?: (p: { business: Business }) => React.ReactNode;
}

export const BusinessesTableContainer = ({ children, businessArray, ...props }: BusinessesTableContainerProps) => {
  const { t: tCommon } = useTranslation('common');

  return (
    <AmountTable hideOnEmpty={props.hideOnEmpty ?? true} title={props.title ?? tCommon('businesses')} {...props}>
      {businessArray?.sort((a, b) => a.name.localeCompare(b.name)).map((business) => children?.({ business }))}
    </AmountTable>
  );
};
